import {i18n} from './i18n';

export function getTestExitMessage(hasTimer, customMessage) {
  const testExitMessage = i18n._(
    'alerts.test_exit_message',
    {},
    {defaults: "Potrai completare l'attività in un secondo momento"}
  );
  const timerTestExitMessage = i18n._(
    'alerts.timer_test_exit_message',
    {},
    {
      defaults:
        "Se esci prima di aver completato l'attività non potrai più ritornare su questa videata",
    }
  );

  return JSON.stringify({
    title: i18n._('alerts.title', {}, {defaults: 'Sei sicuro/a di uscire?'}),
    text: customMessage || (hasTimer ? timerTestExitMessage : testExitMessage),
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: i18n._('alerts.confirm_button', {}, {defaults: 'Sì'}),
    cancelButtonText: i18n._('alerts.cancel_button', {}, {defaults: 'No'}),
  });
}

// ===  For dialog when starting Skillup360 evaluation  ===
export function getEvaluationStartMessage(custom_msg) {
  return JSON.stringify({
    title: i18n._('alerts.title.start_evaluation', {}, {defaults: 'Vuoi iniziare la valutazione?'}),
    text: custom_msg || '',
    type: 'question',
    showCancelButton: true,
    confirmButtonText: i18n._('alerts.confirm_button', {}, {defaults: 'Sì'}),
    cancelButtonText: i18n._('alerts.cancel_button', {}, {defaults: 'No'}),
  });
}

// ===  For dialog when Skillup360 evaluation completes  ===
export function getEvaluationCompleteMessage(custom_msg) {
  return JSON.stringify({
    title: i18n._(
      'alerts.title.evaluation_completed',
      {},
      {defaults: 'Hai completato la valutazione'}
    ),
    text: custom_msg || '',
    type: 'success',
    showCancelButton: false,
    confirmButtonText: 'OK',
    allowOutsideClick: false,
    allowEscapeKey: false,
  });
}
